import React, { useState, useRef, useEffect } from "react";
import NavbarBrandBox from "./NavbarBrandBox";
import { Link, useLocation } from "react-router-dom";
import ProfileDropdownn from "./ProfileDropdownn";
import { useCart } from "./CartContext";
import { showError, showSuccess } from "toast/toast";
import CartDropdown from "./cart/CartDropdown";

import { getAuthCookie } from "../utils/authCookies";
const TeammemberHeader = () => {
  const userName = getAuthCookie("userName");
  const userType = getAuthCookie("userType");
  const token = getAuthCookie("sessionToken");
  const [loading, setLoading] = useState(true);
  const cartDropdownRef = useRef<HTMLDivElement>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { fetchCart } = useCart();
  const licenseType = getAuthCookie("licenseType");
  const location = useLocation();

  useEffect(() => {
    fetchCart();
  }, []);

  useEffect(() => {
    fetchCart();
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        cartDropdownRef.current &&
        !cartDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCartOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRemoveProduct = async (productId: string, variantId: string) => {
    try {
      setLoading(true);

      const token = getAuthCookie("sessionToken");
      const cartId = localStorage.getItem("cart_id");

      if (!token || !cartId) {
        console.error("Missing token or cartId");
        setLoading(false);
        return;
      }
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete product");
      }

      await fetchCart(); // Refresh the cart items
      showSuccess("Product removed successfully!");
    } catch (err) {
      showError("Failed to remove product");
    } finally {
      setLoading(false);
    }
  };

  // Close on ESC (mobile only)
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (window.innerWidth <= 767 && e.key === "Escape") {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // If viewport becomes tablet/desktop, ensure off-canvas is closed
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("vertical-sidebar-enable", "sidebar-enable");
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <NavbarBrandBox />

              <button
                onClick={() => document.body.classList.add("vertical-sidebar-enable")}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item d-inline-flex d-md-none material-shadow-none"
                aria-label="Open sidebar"
              >
                <i className="ri-menu-2-line"></i>
              </button>
            </div>

            <div className="d-flex align-items-center">
              {licenseType !== null && licenseType === "BROKERAGE_TEAM_MEMBER" && (
                <CartDropdown base="teammember" />
              )}
              {/* <NotificationDropdown /> */}
              <ProfileDropdownn
                name={userName || "Guest"}
                role={userType || "Team member"}
                imageUrl=""
                login="teammember"
                token={token || ""}
              />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
}

export default TeammemberHeader;